type Advertiser = {
  advertiserId: number
  companyName: string
  logo: string | null
  domain: string
  lastLoginTimeForUser: string | null
}

const roles = [
  'Super Admin',
  'Sales',
  'Account Manager',
  'Performance Analyst',
  'Portfolio Admin',
  'User',
  'Advertiser Admin',
  'Onboarding Manager',
  'Campaign Manager',
] as const

export type RoleName = (typeof roles)[number]

export function isRoleName(roleName: string): roleName is RoleName {
  return roles.some(role => role === roleName)
}

export type PtvUser = {
  id: number
  emailAddr: string
  currentAdvertiser: Advertiser | null
  advertisers: Advertiser[]
  role: {
    // Note: string & {} is for type discrimination
    name: RoleName | (string & {})
  }
}
